// extracted by mini-css-extract-plugin
export default {"eventPage":"createEvent_eventPage__WkfgF","eventContainer":"createEvent_eventContainer__QuIL4"};